<div class="pl-pane__container--horizontal pl-pane--full-screen">
  <app-ngin-iframe path="user_dashboard/groups"></app-ngin-iframe>
</div>

